<div class="container-fluid">
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start align-items-center">
      <a href="tel:+17205930836" aria-label="Call us at 720-593-0836">
        <i class="fa-solid fa-phone" aria-hidden="true"></i> 720.593.0836
      </a>
    </div>
    <div class="d-flex gap-3 justify-content-end align-items-center">
      <span class="">
        local pasture raised meats since 2013
      </span>
      <ul class="social-icons">
        <li>
          <a href="https://www.facebook.com/LocavoreDelivery" target="_blank" 
            rel="noopener noreferrer" aria-label="Visit our Facebook page" class="text-decoration-none">
            <i class="fa-brands fa-facebook-f" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/locavoredelivery/" target="_blank" 
            rel="noopener noreferrer" aria-label="Visit our Instagram page" class="text-decoration-none">
            <i class="fa-brands fa-instagram" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>